@if (showChip  && !isBulkModeActive) {
    <div class="participant-chip-container">
        <mat-chip-set>
            @if (showParticipantList) {
                <mat-chip 
                    (click)="toggleParticipantList()"
                    class="participant-chip">
                        <!-- <mat-icon matChipAvatar>close</mat-icon> -->
                        X
                </mat-chip>
            } @else {
                <mat-chip 
                    (click)="handleOngoingEventClick()"
                    class="participant-chip on-going-chip">
                        <mat-icon matChipAvatar>person</mat-icon>
                        {{ chipLabel }}
                </mat-chip>
            }
        </mat-chip-set>
    </div>
}

<!-- Custom Chip List Overlay -->
@if (showParticipantList && hasMultipleParticipants && !isBulkModeActive) {
    <div class="chip-list-backdrop" (click)="closeParticipantList()"></div>
    <div class="chip-list-popup" [@slideUp]>
        @for (event of currentEvents; track event.id; let i = $index) {
            <mat-chip class="popup-chip" [style.animation-delay.ms]="i * 50" (click)="openEventDialog(event)">
                <mat-icon matChipAvatar>person</mat-icon>
                <span>
                    {{ event.candidateName }}
                </span>
            </mat-chip>
        }
    </div>
}